import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';

import { MijnNavigatieService, MijnRouteKey } from '@ap/mijn-navigatie';
import { ApContentService } from '@ap/content';

import content from './mijn-titlestrategy.content.json';

@Injectable({ providedIn: 'root' })
export class MijnTitleStrategy extends TitleStrategy {
    private dynamicTitles: Record<string, string> = {};

    constructor(
        private readonly contentService: ApContentService,
        private readonly title: Title
    ) {
        super();
        this.contentService.addContentItems(content);
    }

    public setDynamicTitles(titles: Record<string, string>): void {
        this.dynamicTitles = titles;
    }

    public override updateTitle(): void {
        const routeKey = MijnNavigatieService.getRouteKeyForUrl(window.location.href);
        const divider = '-';

        if (routeKey === MijnRouteKey.SELF_SERVICE_DYNAMIC_PROCESS) {
            const webcomponent = this.getLastUrlSegment(window.location.href);
            const dynamicTitle = this.dynamicTitles[webcomponent];
            if (dynamicTitle) {
                this.title.setTitle(`${dynamicTitle} ${divider} ${this.getBrandPostfix()}`);
                return;
            }
            this.setFallbackTitle();
            return;
        }

        if (!routeKey) {
            this.setFallbackTitle();
            return;
        }

        const title = this.contentService.get(`mijn.omgeving.pageTitleStrategy.${routeKey.toLowerCase()}`);
        if (title && title.length > 0) {
            this.title.setTitle(`${title} ${divider} ${this.getBrandPostfix()}`);
        } else {
            this.setFallbackTitle();
        }
    }

    private getLastUrlSegment(url: string): string {
        return url.split('?')[0].split('#')[0].split('/').filter(Boolean).pop() ?? '';
    }

    private getBrandPostfix(): string {
        return this.contentService.get('mijn.omgeving.pageTitleStrategy.postFix');
    }

    private setFallbackTitle() {
        this.title.setTitle(this.contentService.get('mijn.omgeving.pageTitleStrategy.fallbackTitles'));
    }
}
